<template>
  <div>
    <base-screen>
      <el-form
        size="small"
        :inline="true"
        :model="screenData"
        ref="screenForm"
        @keydown.native.enter="screenSubmit">
        <el-form-item label="服务类型：">
          <el-cascader
            :options="serviceItems"
            v-model="screenData.serviceCodes"
            @change="handleChange"
            placeholder="请选择服务名称"
            :props="defaultProps">
          </el-cascader>
        </el-form-item>
        <el-form-item label="服务客户：" prop="name">
          <el-input type="text" v-model="screenData.name" placeholder="请输入服务客户"
                    autocomplete="off">
          </el-input>
        </el-form-item>
        <el-form-item label="预约时间：">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button class="btn-screen" type="primary" @click="screenSubmit">查询</el-button>
          <el-button type="text" @click="resetScreen">重置</el-button>
        </el-form-item>
      </el-form>
    </base-screen>
    <div class="page-box">
      <div class="tr">
        <el-button v-pms="'editApple'" type="primary" @click="$emit('order-view','order-apple-edit','new')">+ 添加预约</el-button>
      </div>
      <el-table
        :data="tableData"
        v-loading="loading">
        <el-table-column
          prop="createTime"
          label="预约时间"
          width="100">
        </el-table-column>
        <el-table-column
          prop="serviceName"
          label="预约服务">
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="预约时间"
          width="100">
        </el-table-column>
        <el-table-column
          prop="name"
          label="客户名称"
          width="80px">
          <div class="link"
               slot-scope="{row}"
               @click="$emit('order-view','order-detail', row.orderNo)">
            {{ row.name }}
          </div>
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          width="110">
        </el-table-column>
        <el-table-column
          prop="addr"
          label="地址">
        </el-table-column>
        <el-table-column
          prop="tsRemark"
          label="特殊服务">
        </el-table-column>
        <el-table-column
          prop="leaderName"
          label="负责人"
          width="80">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="170">
          <template slot-scope="{row}">
            <el-button class="link" v-pms="'closeApple'" type="text" @click="updateCloseState(row.orderFormId, row.name)">取消预约</el-button>
            <el-button class="link" v-pms="'editApple'" type="text"  @click="$emit('order-view','order-apple-edit', row.orderNo)">编辑</el-button>
            <el-button class="link" :disabled="!row.leaderId"  v-pms="'confirmApple'" type="text" @click="updateAppleState(row.orderFormId, row.name)">确认订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[10, 15, 20]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {order, serve} from '@/api'
import {dateRangeShortcut} from '@/utils/constant'
import dayjs from 'dayjs'
import OrderAppleAdd from './OrderAppleEdit'

export default {
  name: 'PolicyRenewal',
  components: {
    'order-apple-add': OrderAppleAdd
  },
  props: {
    param: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      orgCode: this.$store.state.user.orgCode,
      detailShow: false,
      loading: false,
      screenData: {
        orgCode: this.$store.state.user.orgCode,
        name: '',
        serviceId: '',
        serviceCodes: [],
        orderBeginDate: '',
        orderEndDate: '',
        orderType: 'apple'
      },
      page: {
        pageSize: 10,
        pageNum: 1
      },
      dateRange: '', // 预约时间
      serviceItems: [],
      defaultProps: {
        label: 'name',
        value: 'id'
      },
      tableData: [],
      pickerOptions: {
        shortcuts: dateRangeShortcut
      }
    }
  },
  watch: {
    dateRange (val) {
      this.setScreeData(val)
    }
  },
  created () {
    this.getData()
    this.getSelService()
  },
  methods: {
    changeEvent (value) {
      if (value === 'flush') this.getData()
    },
    async getSelService () {
      let {data} = await serve.getSelTree(this.orgCode)
      this.serviceItems = data
    },
    async handleChange (value) {
      if (value.length > 1) {
        this.screenData.serviceId = value[value.length - 1]
      }
    },
    async updateCloseState (orderFormId, name) { // 确认订单
      this.$confirm('是否取消【' + name + '】的订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postCloseState(orderFormId, name)
      })
    },
    async postCloseState (orderFormId, name) {
      this.loading = true
      let {code, data} = await order.updateOrderState({
        orderFormId: orderFormId,
        orderState: '-1'
      })
      if (code === 0) {
        this.$message({
          message: '【' + name + '】的订单已取消',
          type: 'success'
        })
        this.getData()
      } else {
        this.$message('网络错误请稍后重试')
      }
      this.loading = false
    },
    async updateAppleState (orderFormId, name) { // 确认订单
      this.$confirm('是否确认【' + name + '】的订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postAppleState(orderFormId, name)
      })
    },
    async postAppleState (orderFormId, name) {
      this.loading = true
      let {code, data} = await order.updateOrderState({
        orderFormId: orderFormId,
        orderState: '3'
      })
      if (code === 0) {
        this.$message({
          message: '【' + name + '】的订单确认成功！',
          type: 'success'
        })
        this.getData()
      } else {
        this.$message('网络错误请稍后重试')
      }
      this.loading = false
    },
    setScreeData (val) {
      this.screenData.orderBeginDate = val ? dayjs(val[0]).format('YYYY-MM-DD HH:mm:ss') : ''
      this.screenData.orderEndDate = val ? dayjs(val[1]).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    async getData () {
      this.loading = true
      let {data, page} = await order.getOrderListPage({
        param: this.screenData,
        page: this.page
      })
      this.page = page
      this.loading = false
      this.tableData = data
    },
    screenSubmit () {
      this.page.pageNum = 1
      this.getData()
    },
    resetScreen () {
      this.$refs.screenForm.resetFields()
      this.screenData.serviceCodes = []
      this.screenData.serviceId = ''
      this.setScreeData(false)
      this.dateRange = ''
      this.page.pageNum = 1
      this.getData()
    },
    handleSizeChange (arg) {
      this.page.pageSize = arg
      this.getData()
    },
    handleCurrentChange (arg) {
      this.page.pageNum = arg
      this.getData()
    },
    tabSelected (tab) {
      this.screenData.policyRenewStatPeriod = this.tabsData[tab.index].id
      this.page.pageNum = 1
      this.getData()
    },
    openDetail (id) {
      // this.$refs.policyDetail.getData(id)
    },
    detailShowChange (param) {
      this.detailShow = param
    }
  }
}
</script>

<style lang="scss" scoped>
  .my-autocomplete {
    min-width: 232px;
    width: auto !important;
    li {
      line-height: normal;
      padding: 7px;

      .name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }

      .highlighted .addr {
        color: #ddd;
      }
    }
  }

  .detail-list {
    padding: 24px 0;
    *zoom: 1;
    *clear: both;
    &:before,
    &:after {
      display: table;
      clear: both;
      content: "";
    }
    .list-item {
      float: left;
      width: 33.333333333333%;
      font-size: 14px;
      color: #777;
      line-height: 40px;
      span {
        display: inline-block;
        min-width: 90px;
        text-align: right;
      }
    }
  }
</style>
